import { PianoScript } from './Piano';

const Scripts = () => <PianoScript />;

export default Scripts;
